import { casingUtil } from '@/utils'
import { resolveBirthdayPayload } from '../resolvers'
import { ServerIVA, IVAForm, IVA } from './types'

export const resolveIVADown = (serverIVA: ServerIVA): IVA => {
  const {
    id,
    party,
    entity,
    investment,
    requireAddress,
    requireDob,
    requireDriversLicense,
    requireName,
    requireSsn,
    requireOwnerInfo,
    requireProofOfAddress,
    requireProofOfEin,
    requireProofOfSsn,
    requireCustodianAgreement,
    status,
    ...rest
  } = casingUtil.snakeToCamel(serverIVA)

  return {
    ...rest,
    id,
    partyId: party,
    status,
    entityId: entity,
    investmentId: investment,
    errors: {
      requireAddress,
      requireDob,
      requireDriversLicense,
      requireName,
      requireSsn,
      requireOwnerInfo,
      requireProofOfAddress,
      requireProofOfEin,
      requireProofOfSsn,
      requireCustodianAgreement,
    },
  }
}

export const resolveIVAUp = (form: IVAForm) => {
  const formData = new FormData()
  const resolvedForm = { ...form }

  if (resolvedForm.dateOfBirth) {
    resolvedForm.dateOfBirth = resolveBirthdayPayload(resolvedForm.dateOfBirth)
  }

  Object.entries(resolvedForm).forEach(([name, value]) => {
    if (
      name === 'proofOfSsn' ||
      name === 'proofOfAddress' ||
      name === 'driversLicense' ||
      name === 'ownerInfo' ||
      name === 'proofOfEin' ||
      name === 'custodianAgreement'
    ) {
      const fileObj = Array.isArray(value) ? value[0] : value
      formData.append(casingUtil.camelToSnakeStr(name), fileObj, fileObj.name)
    } else {
      formData.append(casingUtil.camelToSnakeStr(name), value)
    }
  })

  return formData
}
